module.exports = __webpack_public_path__ + "static/media/close.42a57edc.svg";